import React from "react";
import styles from "./styles/PriceList.module.scss";
import Image from "next/future/image";
import BlueHoleIcon from "../../../../public/logo.png";
import { useRouter } from "next/router";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import IcDownload from "./assets/ic-download.svg";
import Link from "next/link";
import secondBg from "../../../assets/images/second-bg.png";
import { buildApiUrl } from "../../../helpers/imageHelpers";

const Index = ({ data }) => {
  const { locale } = useRouter();
  const dir = locale === "ar" ? "rtl" : "ltr";
  const isRtl = locale === "ar";
  const priceListSectionData = data?.posts?.[0];
  const ctaText = priceListSectionData?.data?.cta?.[locale];
  const ctaUrl = priceListSectionData?.data?.ctaUrl
    ?.replace(/^`|`$/g, "")
    ?.trim();
  const isExternalCta = /^https?:\/\//i.test(ctaUrl || "");

  return (
    <div
      className={styles["price-list"]}
      style={{ backgroundImage: `url(${secondBg.src})` }}
      dir={dir}
    >
      <Container>
        <Row className={styles["content-row"]}>
          <Col lg={6} xs={12}>
            <div className={styles["text-side"]}>
              <h2 className={styles.title}>
                {priceListSectionData?.data?.title?.[locale]}
              </h2>

              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: priceListSectionData?.data?.description?.[locale],
                }}
              />

              {ctaText && ctaUrl && (
                <div className="mt-4">
                  {isExternalCta ? (
                    <a
                      href={ctaUrl}
                      target="_blank"
                      rel="noreferrer"
                      className={styles["cta-button"]}
                    >
                      {ctaText}
                      <div className={styles["icon-circle"]}>
                        <svg
                          style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.53577 3.53556L14.1424 14.1422"
                            stroke="black"
                            strokeWidth={1.5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                            stroke="black"
                            strokeWidth={1.5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </a>
                  ) : (
                    <Link href={ctaUrl} passHref>
                      <a className={styles["cta-button"]}>
                        {ctaText}
                        <div className={styles["icon-circle"]}>
                          <svg
                            style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.53577 3.53556L14.1424 14.1422"
                              stroke="black"
                              strokeWidth={1.5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                              stroke="black"
                              strokeWidth={1.5}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </a>
                    </Link>
                  )}
                </div>
              )}
            </div>
          </Col>

          <Col lg={6} xs={12}>
            <div className={styles["image-collage"]}>
              {priceListSectionData?.data?.image && (
                <div className={styles["collage-item"]}>
                  <Image
                    src={buildApiUrl(priceListSectionData?.data?.image)}
                    alt="collage-1"
                    fill
                  />
                </div>
              )}
              {priceListSectionData?.data?.image_new && (
                <div className={`${styles["collage-item"]} ${styles.large}`}>
                  <Image
                    src={buildApiUrl(priceListSectionData?.data?.image_new)}
                    alt="collage-2"
                    fill
                  />
                </div>
              )}
              {priceListSectionData?.data?.file?.name && (
                <div className={styles["collage-item"]}>
                  <Image
                    src={buildApiUrl(priceListSectionData?.data?.file?.name)}
                    alt="collage-3"
                    fill
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Index;
